import { InjectionToken } from "@angular/core";

export let EnvVariables = new InjectionToken("env.variables");


// WEBPACK FOOTER //
// ./envioronment-variables/environment-variables.token.ts